import { reportEntryLog } from '@xt/client/utils/log'

export async function getFile(fileName: string) {
  if (!navigator.storage?.getDirectory) return null

  const root = await navigator.storage.getDirectory()

  try {
    const fileHandle = await root.getFileHandle(fileName)

    const fileData = await fileHandle.getFile()

    return fileData
  } catch (e) {
    reportEntryLog('debug.opfs.read', { success: false, error: e instanceof Error ? e.message : '未知的错误' })
    return null
  }
}

export async function deleteFile(fileName: string) {
  if (!navigator.storage?.getDirectory) return false

  const root = await navigator.storage.getDirectory()

  try {
    await root.removeEntry(fileName)
  } catch (e) {
    reportEntryLog('debug.opfs.delete', { success: false, error: e instanceof Error ? e.message : '未知的错误' })
  }
}

export async function writeFile(fileName: string, file: File) {
  if (!navigator.storage?.getDirectory) return false

  const root = await navigator.storage.getDirectory()

  const fileHandle = await root.getFileHandle(fileName, { create: true })

  const writable = await fileHandle.createWritable()

  await writable.write(file)
  await writable.close()

  reportEntryLog('debug.opfs.write', { success: true, fileName, size: file.size, type: file.type })
  return true
}
